
import { useQuery } from "react-query";
import { db, createQuery } from "../providers/database";
import {
  collectionNames,
  subCollectionNames,
} from "./dictionary/collectionNames";
import {
  doc,

} from "firebase/firestore";
export function useEmployerAndPlans(id: string) {
  return useQuery(
    ["AdminDashboard", { id }],
    createQuery(() => doc(db, collectionNames.adminDashboard, id)),
    { enabled: !!id },
  );
}